export default "__VITE_ASSET__BDCJUwm5__"